module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "joke"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "joke"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "search-area",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 22,
      "sm": 24,
      "lg": 14,
      "xs": 24,
      "id": "joke-selections"
    }
  }, [_c('div', {
    staticClass: "fixed-box"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "选择场景:如动物、家庭。。。",
      "clearable": ""
    },
    model: {
      value: (_vm.scene),
      callback: function($$v) {
        _vm.scene = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "scene"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.handleScenarioChange
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择分级"
    },
    on: {
      "change": _vm.handleRateChange
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  }, _vm._l((_vm.rating), function(key, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": key,
        "value": value
      }
    })
  }))], 1)])], 1), _vm._v(" "), (!_vm.joketotal) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 22,
      "sm": 24,
      "lg": 14,
      "xs": 24
    }
  }, [_c('el-card', {
    attrs: {
      "id": "nothingToshow"
    }
  }, [_c('p', [_vm._v("暂无相关内容")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 22,
      "sm": 24,
      "lg": 14,
      "xs": 24,
      "id": "joke-list"
    }
  }, [_c('div', {
    staticClass: "joke-items"
  }, _vm._l((_vm.jokedata), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "joke-item",
      attrs: {
        "id": 'floor' + index
      }
    }, [_c('div', {
      staticClass: "joke-item-header"
    }, [_c('p', {
      staticClass: "scenario"
    }, [_vm._v(_vm._s(item.scenario))]), _vm._v(" "), _c('p', {
      staticClass: "rating"
    }, [_vm._v(_vm._s(item.rating) + "、" + _vm._s(_vm.jokeRate[item.rating]))])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "joke-item-content"
    }, [_c('div', {
      staticClass: "stuff-info"
    }, [_c('span', [_vm._v("作者：" + _vm._s(item.author))]), _vm._v(" "), _c('span', [_vm._v("审核：" + _vm._s(item.auditor))])]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_vm._v("\r\n                                " + _vm._s(item.tags) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "sound",
      class: {
        active: _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.playMusic(index)
        }
      }
    }, [_c('div', {
      staticClass: "joke-play-button"
    }, [(_vm.isPlayed) ? _c('img', {
      attrs: {
        "src": require("../../static/img/ibroadcast/play.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../static/img/ibroadcast/pause.png")
      }
    })])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "joke-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.joketotal
    },
    on: {
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), (_vm.bgAudio) ? _c('div', {
    staticClass: "bg-audio"
  }, [_c('audio', {
    ref: "bgAudio",
    attrs: {
      "src": _vm.interludeUrl
    },
    on: {
      "ended": function($event) {
        _vm.bgEnd()
      }
    }
  }, [_vm._v("\r\n                抱歉！您的浏览器暂不支持播放此音频，请更换或升级浏览器\r\n            ")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78541b03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/joke/index.vue
// module id = 325
// module chunks = 3